<template>
  <div>
    <div class="d-flex mt-2">
      <VRating
        v-model="stars"
        color="orange darken-2"
        dense
        background-color="grey lighten-2"
        :empty-icon="starIcon"
        :full-icon="starIcon"
        size="25"
        class="pr-4 ml-n1"
        @input="error.errors.rating = null"
      />
      <span class="grey--text text--darken-1 caption font-weight-regular mt-1 ml-n1">
        &mdash;
        {{ $t('rate') }}
      </span>
    </div>
    <div
      v-if="error.errors.rating"
      class="error--text subtitle-2"
    >
      {{ $t('rateWarning') }}
    </div>
    <p class="mt-6 mb-0 body-2 font-weight-regular">
      {{ $t('review') }}
    </p>
    <VTextarea
      v-model="comment"
      outlined
      color="grey lighten-2"
      rows="3"
      :hide-details="!error.errors.comment"
      :error-messages="error.errors.comment"
      :background-color="done ? 'grey lighten-4' : '#ffffff'"
      :disabled="done"
      class="mt-1 mb-6 body-2"
      :placeholder="$t('placeholder')"
      @input="error.errors.comment = null"
    >
      <template #placeholder>
        <span class="body-2 grey--text">
          {{ $t('placeholder') }}
        </span>
      </template>
    </VTextarea>
    <VBtn
      v-if="!done"
      color="success"
      large
      :disabled="!stars && !comment"
      :loading="isLoading"
      @click="submit"
    >
      {{ $t('send') }}
    </VBtn>
    <div v-else class="body-2 font-weight-regular green--text text--accent-4 it-is-done">
      {{ $t('thanks') }}
    </div>
  </div>
</template>

<script>
import { mdiStar } from '@mdi/js';
import httpClient from '../api';
import ApiMixin from '../mixins/ApiMixin';
import RecaptchaMixin from '../mixins/RecaptchaMixin';

export default {
  name: 'FeedbackForm',
  mixins: [ApiMixin, RecaptchaMixin],
  data() {
    return {
      stars: null,
      starIcon: mdiStar,
      comment: null,
      isLoading: false,
      done: false,
      error: this.getInitialErrorData(),
    };
  },
  computed: {
    hasErrorMessageOnly() {
      return !Object.keys(this.error.errors).length && this.error.errorMessage;
    },
  },
  methods: {
    async submit() {
      try {
        const recaptchaToken = await this.getRecaptchaToken('feedback');
        await this.withApiErrorHandling(async () => httpClient.post('feedback', {
          rating: this.stars,
          comment: this.comment,
          recaptchaToken,
        }), 'error', 'isLoading');
        this.done = true;
      } catch (e) {
        if (this.hasErrorMessageOnly) {
          this.$toast.error(this.error.errorMessage);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.it-is-done {
  height: 40px;
  line-height: 40px;
}

::v-deep {
  .v-text-field--outlined fieldset {
    border-color: #E0E0E0;
  }
}
</style>

<i18n locale="en" lang="yaml">
  rate: Please rate our service
  rateWarning: We need your rating
  review: Your review
  placeholder: What did you like or dislike from our service?
  send: Send
  thanks: Thank you for your review!
</i18n>

<i18n locale="ru" lang="yaml">
  rate: Поставьте балл
  rateWarning: Нужно поставить балл
  review: Ваш отзыв
  placeholder: Что вам понравилось или не понравилось в нашем сервисе?
  send: Отправить
  thanks: Спасибо за ваш отзыв!
</i18n>
